import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import { useRegistrationStore } from '../../store/store.ts';
import { TEST_ID } from '../../utils/constants';

type TDepositLimitsButton = {
  handleNext: ({ gtmPayload, redirectTo }: {
    gtmPayload?: Record<string, string>;
    redirectTo?: string;
    canProceed?: boolean;
  }) => void;
  label?: string;
  gtmPayload?: Record<string, string>;
}

const SecondaryDepositLimitsButton = ({ label, gtmPayload, handleNext }: TDepositLimitsButton) => {
  const { setFormData } = useRegistrationStore();

  const handleClick = () => {
    setFormData({ daily: null, weekly: null, monthly: null });
    handleNext({ gtmPayload, redirectTo: '1', canProceed: true });
  };

  return (
    <Button variant="tertiary"
      onClick={handleClick}
      data-testid={TEST_ID.BUTTON_SECONDARY}
    >
      {label}
    </Button>
  )
};

const Memoized = memo(SecondaryDepositLimitsButton);
Memoized.displayName = 'SecondaryDepositLimitsButton';

export default Memoized;
